// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3l6oP","buttons":"PendingPaymentAlert_buttons__2qiKG"};